import { render } from "./PayPalCreditPaymentModal.vue?vue&type=template&id=8b567380&scoped=true"
import script from "./PayPalCreditPaymentModal.vue?vue&type=script&lang=js"
export * from "./PayPalCreditPaymentModal.vue?vue&type=script&lang=js"

import "./PayPalCreditPaymentModal.vue?vue&type=style&index=0&id=8b567380&scoped=true&lang=css"

import exportComponent from "/home/runner/work/web-frontend-dev/web-frontend-dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b567380"]])

export default __exports__